import React, { useState } from 'react';

const AdminSettingsPanel = ({ onClose }) => {
  const [settings, setSettings] = useState({
    siteTitle: 'LogiCar',
    siteDescription: 'Smart car maintenance tracking',
    emailNotifications: true,
    autoBackup: true,
    maintenanceMode: false,
    analyticsEnabled: true
  });

  const handleSettingChange = (key, value) => {
    setSettings(prev => ({
      ...prev,
      [key]: value
    }));
  };

  const handleSaveSettings = () => {
    // Save settings to localStorage or send to server
    localStorage.setItem('adminSettings', JSON.stringify(settings));
    alert('Settings saved successfully!');
  };

  const handleResetSettings = () => {
    if (window.confirm('Are you sure you want to reset all settings to default?')) {
      setSettings({
        siteTitle: 'LogiCar',
        siteDescription: 'Smart car maintenance tracking',
        emailNotifications: true,
        autoBackup: true,
        maintenanceMode: false,
        analyticsEnabled: true
      });
    }
  };

  return (
    <div className="admin-settings-panel">
      <div className="admin-panel-header">
        <h3>System Settings</h3>
        <button className="close-btn" onClick={onClose}>
          <i className="fas fa-times"></i>
        </button>
      </div>

      <div className="settings-sections">
        <div className="settings-section">
          <h4>General Settings</h4>
          <div className="setting-item">
            <label>Site Title</label>
            <input
              type="text"
              value={settings.siteTitle}
              onChange={(e) => handleSettingChange('siteTitle', e.target.value)}
            />
          </div>
          <div className="setting-item">
            <label>Site Description</label>
            <textarea
              value={settings.siteDescription}
              onChange={(e) => handleSettingChange('siteDescription', e.target.value)}
            />
          </div>
        </div>

        <div className="settings-section">
          <h4>Email Settings</h4>
          <div className="setting-item">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.emailNotifications}
                onChange={(e) => handleSettingChange('emailNotifications', e.target.checked)}
              />
              <span>Enable Email Notifications</span>
            </label>
          </div>
          <div className="setting-item">
            <label>Email Template</label>
            <button className="edit-template-btn">
              <i className="fas fa-edit"></i>
              Edit Welcome Email Template
            </button>
          </div>
        </div>

        <div className="settings-section">
          <h4>System Settings</h4>
          <div className="setting-item">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.autoBackup}
                onChange={(e) => handleSettingChange('autoBackup', e.target.checked)}
              />
              <span>Enable Auto Backup</span>
            </label>
          </div>
          <div className="setting-item">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.maintenanceMode}
                onChange={(e) => handleSettingChange('maintenanceMode', e.target.checked)}
              />
              <span>Maintenance Mode</span>
            </label>
          </div>
          <div className="setting-item">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={settings.analyticsEnabled}
                onChange={(e) => handleSettingChange('analyticsEnabled', e.target.checked)}
              />
              <span>Enable Analytics</span>
            </label>
          </div>
        </div>

        <div className="settings-section">
          <h4>Security</h4>
          <div className="setting-item">
            <label>Admin Password</label>
            <button className="change-password-btn">
              <i className="fas fa-key"></i>
              Change Admin Password
            </button>
          </div>
          <div className="setting-item">
            <label>Session Timeout</label>
            <select>
              <option>15 minutes</option>
              <option>30 minutes</option>
              <option>1 hour</option>
              <option>2 hours</option>
            </select>
          </div>
        </div>
      </div>

      <div className="settings-actions">
        <button className="save-btn" onClick={handleSaveSettings}>
          <i className="fas fa-save"></i>
          Save Settings
        </button>
        <button className="reset-btn" onClick={handleResetSettings}>
          <i className="fas fa-undo"></i>
          Reset to Default
        </button>
      </div>
    </div>
  );
};

export default AdminSettingsPanel;
